import { defineMessages } from 'react-intl';

const scope = 'cb.screens.UsedCoupons';

export default defineMessages({
  cantCancelErrorMessage: {
    id: `${scope}.cantCancelErrorMessage`,
    defaultMessage: "Can't cancel coupon. Error: {errorMessage}.",
  },
  emptyReservedTitle: {
    id: `${scope}.emptyReservedTitle`,
    defaultMessage: 'No reserved coupons',
  },
  emptyReservedText: {
    id: `${scope}.emptyReservedText`,
    defaultMessage: "Coupons you reserve will show up here.",
  },
  emptyHistoryTitle: {
    id: `${scope}.emptyHistoryTitle`,
    defaultMessage: 'No coupon history yet',
  },
  emptyHistoryText: {
    id: `${scope}.emptyHistoryText`,
    defaultMessage: "Coupons you've used or that have expired will show up here.",
  },
  backToAccount: {
    id: `${scope}.backToAccount`,
    defaultMessage: 'Back to My Account',
  },
});